import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ChevronLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface BreadcrumbItem {
    key: string
    label: ReactNode
    href?: string
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[]
    className?: string
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ items, className }): ReactNode => {
    return (
        <nav aria-label='مسیر صفحه' className={className}>
            <ol className='flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground'>
                {items.map((item, index) => (
                    <li key={item.key} className='flex items-center gap-2'>
                        {index > 0 && <ChevronLeft className='size-3.5 opacity-60' aria-hidden='true' />}

                        {item.href ? (
                            <Link href={item.href} className='transition-colors hover:text-foreground'>
                                {item.label}
                            </Link>
                        ) : (
                            <span aria-current='page' className={cn('text-foreground')}>
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    )
}
